module.exports = __webpack_public_path__ + "img/aspire_logo.e5180dd5.svg";